import { Card, styled, Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { Theme } from "@mui/material/styles";
import "./Header_module.scss";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";

interface ThemeColors extends Theme {
  colors: any;
  header: any;
  sidebar: any;
  general: any;
}

const HeaderWrapper = styled(Card)(
  ({ theme }: { theme: ThemeColors }) => `
    width: calc(100% - 263px);
    font-size: 14px;
    height: 68px;
    color: black;
    padding: ${theme.spacing(0)};
    right: 0;
    z-index: 6;
    backdrop-filter: blur(3px);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 0;
    
    &.MuiBox-root {
        font-family: 'Poppins', sans-serif;
    }
    
    &.MuiPaper-root {
        box-shadow: none;
        background-color: #EEF1F7;
        width: 100%;
    }
  `
);

interface HeaderProps {
  theme: ThemeColors;
  toggleDrawer: any;
  t: any;
}

function Header({ theme, toggleDrawer, t }: HeaderProps) {
  // @ts-ignore
  const token = window.localStorage.getItem("token") ?? null;

  if (!token) {
    return null;
  }

  return (
    <HeaderWrapper theme={theme}>
      <div className={"header-wrapper"} style={{ width: "100%" }}>
        <Box
          className="hamburger-menu-icon"
          sx={{ display: "none" }}
          onClick={toggleDrawer}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{
              ml: 2,
            }}
          >
            <MenuIcon />
          </IconButton>
        </Box>
        <div className={"breadcrumbs-container"}></div>
        <div className={"profile-container"}>
          <Tooltip title={"Log Out"}>
            <div
              className={"logout-field"}
              onClick={() => {
                localStorage.removeItem("token");
                window.location.reload();
              }}
            >
              <LogoutIcon />
            </div>
          </Tooltip>
        </div>
      </div>
    </HeaderWrapper>
  );
}

export default Header;
